import { Suspense } from 'react';
import styled from 'styled-components';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import Button from '@/common/view/button';
import Text from '@/common/view/Text';
import Spinner from '@/common/view/Spinner';

const LoadingBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
const LoadingView = () => (
  <LoadingBox>
    <Spinner size="medium" type={2} />
  </LoadingBox>
);

const ErrorBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  ${({ theme }) => theme.typescales.body4};
  p,
  pre {
    margin: 0;
  }
`;

const ErrorFallbackComp: React.FC<FallbackProps> = ({
  error,
  resetErrorBoundary /*resetErrorBoundary*/,
}) => {
  // Call resetErrorBoundary() to reset the error boundary and retry the render.
  console.log(error.stack);

  return (
    <ErrorBox>
      <Text typo="body4" color="grayBlack">
        Something went wrong:
      </Text>
      <Text typo="body4" color="red50">
        {`'${error.message}'`}
      </Text>
      <Button
        size="xsmall"
        skin={'gray'}
        onClick={() => {
          console.log('retry');
          window.location.reload();
          //resetErrorBoundary();
        }}>
        페이지 새로고침
      </Button>
    </ErrorBox>
  );
};

const PageFrame = ({ children }: { children: React.ReactNode }) => {
  return (
    <Suspense fallback={<LoadingView />}>
      <ErrorBoundary FallbackComponent={ErrorFallbackComp}>{children}</ErrorBoundary>
    </Suspense>
  );
};

export default PageFrame;
